import React from "react";
import { useFormContext } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormTimePicker,
  StationHookFormSelect,
} from "../../../components";
import { StyledHubCardStack } from "../styles";
import { PartShippingTable } from "../../PartShippingTable";
import { useHighlightableField } from "../../../hooks";

const gap = "10px";

const PartShipping = ({ basePath }) => {
  const { getValues } = useFormContext();
  const { HighlightMenu, getFieldProps } = useHighlightableField();
  const p = `${basePath}.routing.0`;

  // Customer shipping rows still live on `shipping.customers` — they are
  // independent of the routing instructions array and not in scope for
  // this refactor.
  const customers = getValues("shipping.customers");

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Shipping Details</Typography>
        <Stack direction="row" gap={gap}>
          <StationHookFormSelect
            name={`${p}.stationId`}
            label="Station"
            shouldUnregister={false}
            department={8}
            {...getFieldProps(`${p}.stationId`)}
          />
          <HubHookFormTimePicker
            name={`${p}.leadTime`}
            label="Lead Time"
            placeholder="Ex. 12"
            shouldUnregister={false}
            fields={["days"]}
            required
            {...getFieldProps(`${p}.leadTime`)}
          />
          <HubHookFormTimePicker
            name={`${p}.cycleTime`}
            label="Cycle Time"
            placeholder="Ex. 0.24"
            shouldUnregister={false}
            required
            {...getFieldProps(`${p}.cycleTime`)}
          />
        </Stack>
        <HubHookFormInput
          name={`${basePath}.notes`}
          label="Special Instructions"
          placeholder="Shipping notes..."
          shouldUnregister={false}
          rows={5}
          multiline
          {...getFieldProps(`${basePath}.notes`)}
        />
      </Stack>
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">
          Customer Shipping Details
        </Typography>
        <PartShippingTable fields={customers} />
      </Stack>
      {HighlightMenu}
    </StyledHubCardStack>
  );
};

export default PartShipping;
